import React, { useEffect,useState,useRef } from "react";
import axios from 'axios';
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import TableLarge from '../../../local-assets/membership/table-stamp-large.svg';
import TableSmall from '../../../local-assets/membership/table-stamp-small.svg';

const CategoryStamp = () => {
  return (
    <section className="bg-[#F36F21] py-16 md:py-24 text-center text-white px-4">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl md:text-4xl font-bold mb-4">Category Stamp</h3>
        <p className="text-white/95 text-sm md:text-base mb-12 max-w-3xl mx-auto leading-relaxed">
          Category Stamp merupakan Batas maksimal perolehan Stamps dalam 1 (satu) hari 
          untuk setiap member dari akumulasi seluruh kategori
        </p>
        <div className="w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden flex justify-center">
          <img 
            src={TableSmall} 
            alt="Tabel Kategori Mobile" 
            className="block md:hidden w-[90%] h-auto drop-shadow-lg rounded-xl" 
          />
          <img 
            src={TableLarge} 
            alt="Tabel Kategori Desktop" 
            className="hidden md:block w-full max-w-5xl h-auto drop-shadow-lg rounded-xl" 
          />
        </div>
      </div>
    </section>
  );
};

export default CategoryStamp;
